import AbyssHeading from './AbyssHeading';
import FuchiTower from './FuchiTower';

export default function AbyssSection({copy,lang = 'zh-Hant'}) {
  return (
    <section
      className="abyss-section"
      id="abyss"
      aria-labelledby="abyss-title"
    >
      <div className="abyss-sticky">
        <AbyssHeading lang={lang} />
        <FuchiTower lang={lang} />
      </div>
    </section>
  );
}